import React, { FC, memo, ReactElement } from 'react';
import { useNavigate } from 'react-router';
import i18next from 'i18next';
import { Container } from 'react-bootstrap';
import PrimaryButton from './PrimaryButton';

const NotFoundPage: FC = (): ReactElement => {
  const navigate = useNavigate();

  return (
    <Container fluid className="min-vh-100 d-flex align-items-center justify-content-center bg-white">
      <div className="text-center px-3">
        <h1 
          className="fw-bold text-primary mb-2" 
          style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: 'clamp(3rem, 10vw, 100px)',
            lineHeight: 1,
          }}
          aria-label="404">
          404
        </h1>
        
        <h2 className="fw-bold fs-3 text-dark mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          {i18next.t('notFound.subTitle')}
        </h2>
        
        <p className="mx-auto mb-3 text-dark" style={{ fontFamily: 'Montserrat, sans-serif', maxWidth: '640px' }}>
          {i18next.t('notFound.body')}
        </p>
        
        <PrimaryButton size="lg" onClick={() => navigate('/patients')}>
          {i18next.t('notFound.buttonText')}
        </PrimaryButton>
      </div>
    </Container>
  );
};

export default memo(NotFoundPage);
